<template>
  <div class="token-doesnt-exist">
    <div class="status-text">No Token</div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'token-doesnt-exist',
  components: {
    CompIcon
  },
  data: function () {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.token-doesnt-exist {
  /* common */
  background-color: #000;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.token-doesnt-exist .status-text {
  /* common */
  color: #fff;
  font-size: 16px;
  /* text */
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/TokenDoesntExist.vue